import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fb768de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "board-history-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], { title: "탑승내역" }),
        _createVNode($setup["BoardHistoryTable"], {
          class: "board-history-table-container",
          boardHistory: $setup.boardHistory,
          shouldShowEmptyContent: $setup.shouldShowEmptyContent,
          searchFromDate: $setup.searchFromDate,
          searchToDate: $setup.searchToDate,
          onOnClickFromDateInput: $setup.showFromDateCalendar,
          onOnClickToDateInput: $setup.showToDateCalendar,
          onOnSelectBoardInfo: $setup.showBoardHistoryDetail
        }, null, 8 /* PROPS */, ["boardHistory", "shouldShowEmptyContent", "searchFromDate", "searchToDate"])
      ]),
      ($setup.shouldShowFromDateCalendar)
        ? (_openBlock(), _createBlock($setup["Calendar"], {
            key: 0,
            initialSelectedDate: $setup.searchFromDate,
            selectableFromDate: $setup.limitFromBoardDate,
            selectableToDate: $setup.limitEndBoardDate,
            onOnSelectDate: $setup.onSelectFromDate,
            onOnClickClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.shouldShowFromDateCalendar = false))
          }, null, 8 /* PROPS */, ["initialSelectedDate", "selectableFromDate", "selectableToDate"]))
        : _createCommentVNode("v-if", true),
      ($setup.shouldShowToDateCalendar)
        ? (_openBlock(), _createBlock($setup["Calendar"], {
            key: 1,
            initialSelectedDate: $setup.searchToDate,
            selectableFromDate: $setup.limitFromBoardDate,
            selectableToDate: $setup.limitEndBoardDate,
            onOnSelectDate: $setup.onSelectToDate,
            onOnClickClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.shouldShowToDateCalendar = false))
          }, null, 8 /* PROPS */, ["initialSelectedDate", "selectableFromDate", "selectableToDate"]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode("\n    <transition name=\"slide-up\">\n      <div class=\"board-history-detail\" v-if=\"shouldShowBoardHistoryDetail\">\n        <BoardHistoryDetail\n          :boardInfo=\"selectedBoardInfo!\"\n          @onClickClose=\"toggleShowBoardHistoryDetail(false)\"\n          @onCompleteSurvey=\"onCompleteSurvey\"\n        />\n      </div>\n    </transition>\n    ")
    ]),
    _: 1 /* STABLE */
  }))
}